import React from 'react';
import {
  FormControl, FormGroup, HelpBlock, InputGroup, Label,
} from 'react-bootstrap';
import _ from 'lodash';
import { OperatorCountries } from '../helpers/constants';
import { AlacrityDropdown } from './AlacrityDropdown';
import { getLS, validateMsisdn } from '../helpers/utils';
import Logo from './Logo';
import LogoWhite from './LogoWhite';

function getValidationState(val, countryCode, e) {
  const getValidated = validateMsisdn(val, countryCode);
  if (getValidated) {
    return 'error';
  }
}

function getErrorText(val, countryCode, e) {
  const getValidated = validateMsisdn(val, countryCode);
  if (getValidated) {
    return "Country code detected or there's 0 in front of your mobile number";
  }
  return '';
}

function LoginPin(lblPinMsg) {
  return [
    <div key={`login${lblPinMsg}`} className={getLS('dark') === 'true' ? 'fontNormal fontNormal-dark ' : 'fontNormal '}><Label>{lblPinMsg}</Label></div>,
    <br key={`br${lblPinMsg}`} />,
  ];
}

function isNumberKey(e) {
  let checkIfNum;
  // eslint-disable-next-line no-useless-escape
  const pattern = /^[a-zA-Z!@#\$%\^\&*\)\(+=._-]+$/;
  if (e.keyCode !== undefined) {
    checkIfNum = pattern.test(String.fromCharCode(e.keyCode)) || pattern.test((e.key)) && (e.keyCode !== 8);
  }

  return checkIfNum && e.preventDefault();
}

function LoginDefault(val, placeholder, handleChange, lblBtnMsg) {
  return [
    // eslint-disable-next-line react/jsx-key
    <FormControl
      className={getLS('dark') === 'true' ? 'form-control-dark row-cols-sm-4 form-width' : 'row-cols-sm-4 form-width'}
      type="text"
      value={val}
      placeholder={placeholder}
      onChange={handleChange}
      required
      onKeyDown={(e) => isNumberKey(e)}
      maxLength="10"

      // onInput={(e) =>{
      //   e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,10);
      // }}
    />,
    // eslint-disable-next-line react/jsx-key
    <div className="caption"><Label>{lblBtnMsg}</Label></div>,
  ];
}

const formatInput = (e) => {
  // Prevent characters that are not numbers ("e", ".", "+" & "-") ✨
  let checkIfNum;
  if (e.key !== undefined) {
    // Check if it's a "e", ".", "+" or "-"
    checkIfNum = e.key === 'e' || e.key === '.' || e.key === '+' || e.key === '-';
  } else if (e.keyCode !== undefined) {
    // Check if it's a "e" (69), "." (190), "+" (187) or "-" (189)
    checkIfNum = e.keyCode === 69 || e.keyCode === 190 || e.keyCode === 187 || e.keyCode === 189;
  }

  return checkIfNum && e.preventDefault();
};

const Login = ({
  width, val, lblInstruction, handleSubmit, handleChange, handleCancel, lblBtnMsg, lblBtn, className, placeholder, type, lblPinMsg, isLoading, lblBtnWhileLoading, handleOperatorChange, options, handleCountryChange, countryCode, disabled, btnDisabled,
}) => (
  <div data-test="component-login">
    <div className={getLS('dark') === 'true' ? 'new_container-fluid body-dark' : 'new_container-fluid'}>
      {/* eslint-disable-next-line no-nested-ternary */}
      <div className={width < 600 ? getLS('dark') === 'true' ? 'new_navbar-default body-dark' : 'new_navbar-default' : getLS('dark') === 'true' ? 'new_navbar-default navbar-align body-dark' : 'new_navbar-default navbar-align'}>
        {getLS('dark') === 'true' ? <LogoWhite /> : <Logo />}
      </div>
      {/* eslint-disable-next-line no-nested-ternary */}
      <div className={width < 600 ? getLS('dark') === 'true' ? 'login-clean login-clean-small login-clean-dark' : 'login-clean login-clean-small' : getLS('dark') === 'true' ? 'login-clean login-clean-dark' : 'login-clean'}>
        <form id="#loginForm" name="form" onSubmit={handleSubmit} data-test="component-login-form">
          <FormGroup>
            {/* <FormGroup validationState={getValidationState(val)}> */}
            <div className="form-group" data-test="component-login-form-control">
              {width < 600 ? <h4><Label>{lblInstruction}</Label></h4> : <h3><Label>{lblInstruction}</Label></h3>}
              {type === 'LoginPin' ? LoginPin(lblPinMsg) : null}
              {/* eslint-disable-next-line no-nested-ternary */}
              {type === 'LoginPin' ? LoginDefault(val, placeholder, handleChange, lblBtnMsg)

                : width < 600
                  ? (
                    <div className="form-group">

                      <div className="col-md-3">
                        <AlacrityDropdown
                          options={OperatorCountries}
                          title="Country"
                          id="country"
                          onChange={handleCountryChange}
                          className="btn btn-success dropdown-toggle form-control"
                          renderOptionCustomized
                          btnDropDown
                        />
                      </div>
                      <div className="col-md-3">
                        <AlacrityDropdown
                          options={!_.isEmpty(options) ? options : []}
                          title="Operator"
                          onChange={handleOperatorChange}
                          className="btn btn-success dropdown-toggle form-control"
                          renderOptionCustomized
                          btnDropDown
                        />
                      </div>
                      <div className="col-md-12 mt-0 pt-0">
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon className="no-border w-30">
                              <FormControl
                                readOnly
                                id="frmControlAutoPrefixCountryCode"
                                className={getLS('dark') === 'true' ? 'form-control-dark form-control text-right left-border-mobile mt-1 pt-1 ' : 'form-control text-right left-border-mobile mt-1 pt-1 '}
                                type="number"
                                value={countryCode}
                                placeholder="Intl. Code"
                                required
                              />
                            </InputGroup.Addon>
                            <FormControl
                              readOnly={disabled}
                              id="frmMsisdn2"
                              className="row-cols-sm-4 mt-1 pt-1 w-75"
                              type="number"
                              value={val}
                              placeholder={placeholder}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              onKeyDown={(e) => formatInput(e)}
                            />
                            <HelpBlock className="text-danger small">{getErrorText(val, countryCode)}</HelpBlock>
                          </InputGroup>
                        </FormGroup>
                      </div>

                    </div>
                  )
                  : (
                    <div className="row">
                      <div className="col-6 mr-0 pr-0">
                        <AlacrityDropdown
                          options={OperatorCountries}
                          title="Country"
                          id="country"
                          onChange={handleCountryChange}
                          className="btn btn-success dropdown-toggle form-control"
                          renderOptionCustomized
                          btnDropDown
                        />
                      </div>
                      <div className="col-6 mb-0 pb-0">
                        <AlacrityDropdown
                          options={!_.isEmpty(options) ? options : []}
                          title="Operator"
                          onChange={handleOperatorChange}
                          className="btn btn-success dropdown-toggle form-control"
                          renderOptionCustomized
                          btnDropDown
                        />
                      </div>
                      <div className="col-12">
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon className={getLS('dark') === 'true' ? 'left-border-dark' : 'left-border '}>
                              <FormControl
                                readOnly
                                id="frmControlAutoPrefixCountryCode"
                                className={getLS('dark') === 'true' ? 'form-control-dark form-control row-cols-sm-4 text-right ' : 'form-control row-cols-sm-4 text-right '}
                                type="number"
                                value={countryCode}
                                placeholder="Intl. Code"
                                required
                              />
                            </InputGroup.Addon>
                            <FormControl
                              readOnly={disabled}
                              id="frmMsisdn2"
                              className={getLS('dark') === 'true' ? 'form-control-dark row-cols-sm-4 ' : 'row-cols-sm-4 '}
                              type="number"
                              value={val}
                              placeholder={placeholder}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              onKeyDown={(e) => formatInput(e)}
                            />
                            <HelpBlock className="text-danger small" />
                          </InputGroup>
                          <HelpBlock className="text-danger small">{getErrorText(val, countryCode)}</HelpBlock>
                        </FormGroup>
                      </div>

                      {/**/}
                    </div>
                  )}
            </div>
            <div className="form-group">
              <button
                type="button"
                data-test="submit-button"
                id="btnLogin"
                className={getLS('dark') === 'true' ? 'btn btn-primary p-2 btn-dark' : 'btn btn-primary p-2'}
                onClick={handleSubmit}
                disabled={btnDisabled}
              >
                {isLoading ? lblBtnWhileLoading : lblBtn}
                {isLoading
                  && <i className="fa fa-refresh fa-spin" style={{ marginLeft: '25px' }} />}
              </button>
              {type === 'LoginPin' ? <button type="button" id="cancel" className={getLS('dark') === 'true' ? 'btn btn-secondary btn-block d-inline p-2' : 'btn btn-light btn-block d-inline p-2'} onClick={handleCancel}>Cancel</button> : null}
            </div>
          </FormGroup>
        </form>
      </div>

    </div>

  </div>

);

export { Login };
export default Login;
